// Display helpers for a plan influencer row — formatCount backs the Plans
// screens, formatCompact the Script Approval screens.

export const formatCompact = (num) => {
  if (num === null || num === undefined) return "—";
  return new Intl.NumberFormat("en", { notation: "compact" }).format(num);
};

// Full, exact count with Indian digit grouping (4,93,000 rather than "493K")
// — what the Plans screens show for followers and averages, matching the ₹
// totals in the Plan Summary header. Averages can be fractional, so round to
// a whole count.
export const formatCount = (num) => {
  if (num === null || num === undefined || num === "" || Number.isNaN(Number(num))) return "—";
  return Math.round(Number(num)).toLocaleString("en-IN");
};

// Some records store a platform-prefixed key (e.g. "yt/@handle", "fb/handle")
// used internally for DB lookups — strip that prefix for display.
export const formatUsername = (username) => {
  if (!username) return null;
  // "tw/" (X) and "li/" (LinkedIn) are the same kind of internal prefix as "yt/"; a LinkedIn
  // company page is stored as "li/c/<slug>" and shown as "company/<slug>".
  const cleaned = username
    .replace(/^li\/c\//, "company/")
    .replace(/^(yt|fb|t|tw|li)\//, "")
    .replace(/^@/, "");
  return cleaned || null;
};
